<template>
    <div class="row justify-content-sm-center">
        <div class="col-lg-6 col-md-8 col-sm-12">
            <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                <!-- Your first and last name (full width) -->
                <div class="form-group mb-2">
                    <label class="full">
                        <span>Your first and last name</span><span class="brand ml-1">*</span>
                        <input v-model="form.name" type="text" placeholder="Please add your name">
                    </label>

                    <div v-if="$v.form.name.$invalid" class="error">
                        <span v-if="!$v.form.name.required">Your first and last name are required.</span>
                        <span v-if="!$v.form.name.minLength">Your first and last name must have at least 4 characters.</span>
                    </div>
                </div>

                <!-- Company brand name (full width) -->
                <div class="form-group mb-2">
                    <label class="full">
                        Company brand name<span class="brand ml-1">*</span>
                        <input v-model="form.brand" type="text" placeholder="Company brand name">
                    </label>

                    <div v-if="$v.form.brand.$invalid" class="error">
                        <span v-if="!$v.form.brand.required">Company brand name is required.</span>
                        <span v-if="!$v.form.brand.minLength">Your company brand must have at least 3 characters.</span>
                    </div>
                </div>

                <!-- Company Address (full width) -->
                <div class="form-group mb-2">
                    <label class="full">
                        Company Address<span class="brand ml-1">*</span>
                        <input v-model="form.companyAddress" type="text" placeholder="Company Address">
                    </label>

                    <div v-if="$v.form.companyAddress.$invalid" class="error">
                        <span v-if="!$v.form.companyAddress.required">Company Address is required.</span>
                    </div>
                </div>

                <!-- Company Address & Country side by side -->
                <div class="row">
                    <div class="col-md-6">
                        <!-- ZIP-Code -->
                        <div class="form-group mb-2">
                            <label class="full">
                                ZIP-Code<span class="brand ml-1">*</span>
                                <input v-model="form.zipCode" type="text" placeholder="ZIP-Code">
                            </label>

                            <div v-if="$v.form.zipCode.$invalid" class="error">
                                <span v-if="!$v.form.zipCode.required">ZIP-Code is required.</span>
                            </div>
                        </div>

                        <!-- Country select-->
                        <div class="form-group mb-2">
                             <label class="full">
                                Country<span class="brand ml-1">*</span>
                             </label>

                            <country-picker :openDirection="'top'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
                           
                            <div v-if="$v.form.country && $v.form.country.$invalid" class="error">
                                <span v-if="!$v.form.country.required">Country is required.</span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6">
                        <!-- Location -->
                        <div class="form-group mb-2">
                            <label class="full">
                                Location<span class="brand ml-1">*</span>
                                <input v-model="form.location" type="text" placeholder="Location">
                            </label>

                            <div v-if="$v.form.location.$invalid" class="error">
                                <span v-if="!$v.form.location.required">Location is required.</span>
                            </div>
                        </div>
                        <!-- VAT Number -->
                        <div class="form-group mb-2">
                            <label class="full">
                                VAT Number<span class="brand ml-1">*</span>
                                <input v-model="form.vatNumber" type="text" placeholder="VAT">
                            </label>

                            <div v-if="$v.form.vatNumber.$invalid" class="error">
                                <span v-if="!$v.form.vatNumber.required">VAT Number is required.</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Email (full width) -->
                <div class="form-group mb-2">
                    <label class="full">
                        Email<span class="brand ml-1">*</span>
                        <input v-model="form.email" type="email" placeholder="Your email">
                    </label>

                    <div v-if="$v.form.email.$invalid" class="error">
                        <span v-if="!$v.form.email.required">Email is required.</span>
                        <span v-if="!$v.form.email.email">Must be a valid email</span>
                    </div>
                </div>

                <!-- Password (full width) -->
                <div class="form-group mb-2">
                    <label class="full">
                        Password<span class="brand ml-1">*</span>
                        <input v-model.trim="form.password" type="password" placeholder="Your password">
                    </label>

                    <div v-if="$v.form.password.$invalid" class="error">
                        <span v-if="!$v.form.password.required">Please type a password.</span>
                        <span v-if="!$v.form.password.minLength">Minimum length of 6 characters.</span>
                    </div>
                </div>

                <!-- Terms and submit -->
                <div class="fs-smaller mt-5 mb-1">
                    <checkbox class="d-inline" name="terms" value="true" v-model="form.hasAcceptTermsConditions"></checkbox>
                    I accept the
                    <span class="darker underlined pointer" @click="openConditions">Terms of Service and Privacy Policy</span>
                </div>
                <input type="submit" class="btn action widest full" value="Sign up free" :disabled="$v.form.$invalid">
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'

import extendedVSelect from '@/extends/vue-select'
import CountryPicker from '@/tools/CountryPicker.vue'

export default {
    data() {
        return {
            step: 1,
            form: {
                brand: '',
                name: '',
                zipCode: '',
                companyAddress: '',
                vatNumber: '',
                location: '',
                country: '',
                email: '',
                password: '',
                hasAcceptTermsConditions: false
            },
            selectedPosition: null,
            selectedCountry: null,
        }
    },
    validations: {
        form: {
            brand: {
                required,
                minLength: minLength(3)
            },
            name: {
                required,
                minLength: minLength(4)
            },
            zipCode: {
                required
            },
            companyAddress: {
                required
            },
            vatNumber: {
                required
            },
            location: {
                required
            },
            country: {
                required
            },
            email: {
                required,
                email,
            },
            password: {
                required,
                minLength: minLength(6)
            },
            hasAcceptTermsConditions: {
                required,
            }
        },
    },
    created() {
        this.eventHub.$emit('sidebar', 'signup');
        this.eventHub.$emit('topLink', 'login');

        // If we com from 'back button', fill the form | Else start from scratch
        if (this.accountSetup.email) {
            this.form = this.accountSetup;
        } else {
            this.resetAccountSetup('supplier');
        }

        if (this.form.country) {
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == this.form.country;
            })[0];
        }
    },
    computed: {
        ...mapGetters([
            'accountSetup',
            'getCountries'
        ])
    },
    methods: {
        ...mapActions([
            'resetAccountSetup',
            'updateAccountSetup'
        ]),
        updateCountry(e) {
            this.selectedCountry = e;
            this.$set(this.form, 'country', e.id);
        },
        processForm() {
            this.form.step = this.step + 1;

            // Update account setup data
            this.updateAccountSetup(this.form);

            // Move on to step 2
            this.$router.push({ name: 'auth.signup.supplier.create' });
        },
        openConditions() {
            window.open('https://pluralo.com/terms-and-conditions/for-suppliers/', '_blank');
        },
    },
    components: {
        vSelect: extendedVSelect,
        CountryPicker
    }
}
</script>

<style lang="scss" scoped>
    .form-group {
        min-height: 4.75rem;
    }
</style>



// WEBPACK FOOTER //
// Step1.vue?7b8c6eed